<div class="filter">
  <div class="spen-ly-modal" id="modal">
    <div class="modal-dialog">
      <div class="inner">
        <div class="modal-heading">
          <span class="top-btn-close" (click)="onBack()">
            <i class="fa fa-chevron-left"></i>
          </span>
          <h2 class="heading-text">既存の活動記録</h2>
        </div>
        @if (dataLoaded()) {
          <div class="modal-content has-footer">
            @if (isDocumentRecord()) {
              <div class="segments">
                <app-segment-view [tabOptions]="tabOptions" (switchTab)="switchTab($event)"></app-segment-view>
              </div>
            }
            @if (isQuestionnaireRecord()) {
              <app-questionnaire-detail-student [questionnaire]="activityRecord.record"></app-questionnaire-detail-student>
            }
            @if (isDocumentRecord()) {
              @switch (currentTab) {
                @case ('self') {
                  <app-document-detail-student
                    [document]="activityRecord?.record"
                    [categoryName]="activityRecord?.category_name"
                    [marks]="activityRecord?.marks"
                    [option]="{ inAlbum: true }"
                    [document_answers]="activityRecord.record.document_answers"
                    [isCompassAnswer]="activityRecord?.is_compass_answer"
                  >
                  </app-document-detail-student>
                }
                @case ('cross_assessment') {
                  <app-student-cross-assessments [crossAssessments]="activityRecord.cross_assessments"> </app-student-cross-assessments>
                }
                @case ('teacher_assessment') {
                  <h2 class="assessments-header">先生からのコメント</h2>
                  @for (assessment of activityRecord.assessments; track assessment.id; let isFirst = $first) {
                    <div>
                      <app-student-assessment-detail [assessment]="assessment" [canEdit]="false" [isFirst]="isFirst">
                      </app-student-assessment-detail>
                    </div>
                  }
                }
              }
            }
            <div class="block-last">
              <button class="spen-mod-btn" (click)="addActivityToAlbum()" [disabled]="submitting">アルバムに追加する</button>
            </div>
          </div>
        } @else {
          <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
        }
      </div>
    </div>
  </div>
</div>
